import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-ios-udid-finder-info-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './ios-udid-finder-info-section.component.html',
  styleUrl: './ios-udid-finder-info-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosUdidFinderInfoSectionComponent {
  protected readonly features = [
    {
      icon: '@tui.globe',
      title: 'No Mac Required',
      description:
        'Find your iPhone or iPad UDID directly from your device. No computer, Xcode, or iTunes needed.',
    },
    {
      icon: '@tui.zap',
      title: 'Instant Results',
      description:
        'Get your UDID, device name, serial number, IMEI, and iOS version in seconds.',
    },
    {
      icon: '@tui.shield-check',
      title: 'Privacy-First',
      description:
        'The configuration profile is used only to retrieve your device information. No data is stored on our servers.',
    },
  ];
}
